import suppressGlobalErrors from './suppressGlobalErrors';
import {
  getSurvey,
  checkForResponse,
  postSurveyResponse,
  postSurvey,
  sendSurveyNotification,
  putSurvey
} from '../api';

export const ANSWER_SURVEY_QUESTION = 'ANSWER_SURVEY_QUESTION';
export const CHECK_FOR_RESPONSE = 'CHECK_FOR_RESPONSE';
export const CLEAR_QUESTION_RESPONSES = 'CLEAR_QUESTION_RESPONSES';
export const CLEAR_SURVEY = 'CLEAR_SURVEY';
export const GET_SURVEY = 'GET_SURVEY';
export const GET_SURVEY_FULFILLED = 'GET_SURVEY_FULFILLED';
export const GET_SURVEYS = 'GET_SURVEYS';
export const POST_SURVEY_RESPONSE = 'POST_SURVEY_RESPONSE';
export const SEND_SURVEY_NOTIFICATION = 'SEND_SURVEY_NOTIFICATION';
export const SUBMIT_SURVEY = 'SUBMIT_SURVEY';
export const SUBMIT_SURVEY_FULFILLED = 'SUBMIT_SURVEY_FULFILLED';
export const UPDATE_RESEARCH_CONSENT = 'UPDATE_RESEARCH_CONSENT';
export const UPDATE_SURVEY_OPTIONS = 'UPDATE_SURVEY_OPTIONS';

export const answerSurveyQuestionAction = (questionId, questionResponse) => ({
  type: ANSWER_SURVEY_QUESTION,
  payload: {
    questionId,
    questionResponse
  }
});

export const checkForResponseAction = (surveyId) => suppressGlobalErrors({
  type: CHECK_FOR_RESPONSE,
  payload: checkForResponse(surveyId)
});

export const clearQuestionResponsesAction = () => ({
  type: CLEAR_QUESTION_RESPONSES
});

export const clearSurveyAction = () => ({
  type: CLEAR_SURVEY
});

export const getSurveyAction = (surveyId) => ({
  type: GET_SURVEY,
  payload: getSurvey(surveyId)
});

export const postSurveyResponseAction = (surveyId, responseData) => ({
  type: POST_SURVEY_RESPONSE,
  payload: postSurveyResponse(surveyId, responseData)
});

export const sendNotificationAction =
  (surveyId, title, message, onlyUnansweredParticipants = false) => ({
    type: SEND_SURVEY_NOTIFICATION,
    payload: sendSurveyNotification(surveyId,
      { title, message, onlyUnansweredParticipants })
  });

export const submitSurveyAction = (surveyData) => ({
  type: SUBMIT_SURVEY,
  payload: (surveyData.id ? putSurvey : postSurvey)(surveyData)
});

export const updateResearchConsentAction = (consent) => ({
  type: UPDATE_RESEARCH_CONSENT,
  payload: consent
});

export const updateSurveyOptionsAction = (surveyOptions) => ({
  type: UPDATE_SURVEY_OPTIONS,
  surveyOptions
});
